import BookForm from "components/shared/book/form";
import React from "react";
import { config, initialState } from "../formConfig";

class FormScenario extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        const { name, description, externalData, intFlags } = config;
        return (
            <>
                {this.renderField(name)}
                {this.renderField(description)}
                {this.renderField({
                    ...externalData.config.propertyName,
                    value: this.state.externalData.propertyName,
                    onChange: ({ name, value }) =>
                        this.setValue({ name: "externalData", value: { ...this.state.externalData, [name]: value } }),
                })}
                {this.renderFlags(intFlags)}
            </>
        );
    };
}

const ConfiguredForm = (props) => <FormScenario {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
